import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_ERROR
} from '@/consts/enums'

import { NotificationProgrammatic as Notification } from 'buefy'

export default {
  showSuccess(text, duration = 6000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_SUCCESS, text, dismissible, duration)
  },
  showInfo(text, duration = 6000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_INFO, text, dismissible, duration)
  },
  showWarning(text, duration = 8000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_WARNING, text, dismissible, duration)
  },
  showError(text, duration = 8000, dismissible = true) {
    addNotification(NOTIFICATION_TYPE_ERROR, text, dismissible, duration)
  }
}

function addNotification(type, text, dismissible, duration) {
  let notificationType = 'is-info'
  switch (type) {
    case NOTIFICATION_TYPE_SUCCESS: {
      notificationType = 'is-success'
      break
    }
    case NOTIFICATION_TYPE_WARNING: {
      notificationType = 'is-warning'
      break
    }
    case NOTIFICATION_TYPE_ERROR: {
      notificationType = 'is-danger'
      break
    }
  }

  Notification.open({
    message: text,
    type: notificationType,
    closable: dismissible,
    indefinite: duration === -1,
    duration: Math.max(0, duration),
    position: 'is-top-right',
    queue: false
  })
}
